import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GeolocationRequestService {
  private _isGeolocationView = signal<boolean>(false);
  public isGeolocationView = this._isGeolocationView.asReadonly();

  setIsGeolocationView(value: boolean) {
    this._isGeolocationView.set(value);
  }
}
